import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { GameTags } from '@core/models/game-tags.model';

@Injectable()
export class GameTagsDataService extends DefaultDataService<GameTags>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('GameTags', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<GameTags[]> {
    return this.http.get<ApiResponse>('/game-tags').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<GameTags[]> {
    return this.http.get<ApiResponse>(`/game-tags${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getGameTag(id: number) {
    return this.http.get<ApiResponse>(`/game-tags/${id}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data)
    );
  }

  createGameTag(param: any) {
    return this.http.post<ApiResponse>(`/game-tags`, param).pipe(
      tap( res => this.messages$.next(res.message)),
    );
  }

  updateGameTag(id: number, param: any) {
    return this.http.put<ApiResponse>(`/game-tags/${id}`, param).pipe(
      tap( res => this.messages$.next(res.message)),
    );
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }
}
